import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

/* Actions */
import {
	setRequestCreditDetails
} from '../../../../redux/actions';

import GenericOverlayDialog from '../../../dialogs/genericOverlayDialog';

class RequestCreditAsIsPriceAdjustment extends Component {
	constructor(props) {
		super(props);
		this.state = {
			batchSizeForAddressList: 50,
			errorMessage: '',
			requestCreditDetails: null,
			accountNumberDetails: [],

			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
		};
		this.handleDialog = this.handleDialog.bind(this);
		this.updateItemWithPricing = this.updateItemWithPricing.bind(this);
		this.makeSubbedModelPriceOrderCall = this.makeSubbedModelPriceOrderCall.bind(this);
		this.manipulateClipBoardOfShouldBePrice = this.manipulateClipBoardOfShouldBePrice.bind(this);
	}
	componentDidMount() {
		window.scrollTo(0, 0);
		const self = this;
		// Redirect to request return page if there is no data in store, it means page is refreshed
		if(!self.props.order.requestCreditDetails) {
			browserHistory.push("/requestcredit");
		} else {
			const { requestCreditDetails, requestCreditFilterListOfOrders } = self.props.order;
			const creditType = requestCreditFilterListOfOrders && requestCreditFilterListOfOrders.param ? requestCreditFilterListOfOrders.param.creditType: '';
			let accountNumberDetails = [];
			// pull account number details from previous step as it is as all service calls were already completed before coming to this step.
			if (requestCreditDetails.accountNumberDetails) {
				accountNumberDetails = JSON.parse(JSON.stringify(requestCreditDetails.accountNumberDetails));
				// delete requestCreditDetails.accountNumberDetails;
			}
			self.setState({
				requestCreditDetails,
				accountNumberDetails,
				creditType,
			});
		}
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleCancel() {
		browserHistory.push("/requestcredit");
	}

	handleContinue() {
		const self = this;
		let formError = false;
		const accountNumbers = [];
		const requestCreditDetails = self.state.requestCreditDetails;
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			if(item.selected) {
				item.accountNumberError = item.accountNumber ? '' : 'error';
				item.agreementNumberError = item.agreementNumber ? '' : 'error';
				item.shouldBePriceError = item.shouldBePrice && !item.shouldBePrice.endsWith('.') ? '' : 'error';
				if(item.accountNumberError || item.agreementNumberError || item.shouldBePriceError) {
					formError = true;
				} else {
					item.creditAmount = parseFloat(item.price) * parseFloat(item.returnQuantity);
				}
				if(accountNumbers.indexOf(item.accountNumber) === -1) {
					accountNumbers.push(item.accountNumber);
				}
			}
		});
		// Check if different account numbers are selected. If yes then show dialog and stay on same page
		if(accountNumbers.length > 1) {
			formError = true;
			self.setState({
				genericDialogHeading: "Action",
				genericDialogText: "Please select same account number for all lines.",
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true);
			});
		}
		self.setState({
			requestCreditDetails
		}, () => {
			if(!formError) {
				let requestCreditDetails = self.state.requestCreditDetails;
				requestCreditDetails = {
					...requestCreditDetails,
					responseObject: {
						...requestCreditDetails.responseObject,
						defaultShipToAddress: self.props.getDefaultShippingAddressForSelectedAccount(accountNumbers[0].toString(), self.state.accountNumberDetails)
					},
					accountNumberDetails: self.state.accountNumberDetails,
				};
				let subbedModel = [];
				requestCreditDetails.responseObject.items.forEach(item => {
					if (item.subbedModel) {
						subbedModel.push(item.subbedModel);
					}
				});
				if (subbedModel.length > 0 && !requestCreditDetails.responseObject.creditInvoiceNotes) {
					requestCreditDetails.responseObject.creditInvoiceNotes = `Subbed for model: ${subbedModel.join(', ')}`;
				}
				self.props.setRequestCreditDetails(requestCreditDetails);
				browserHistory.push('/requestCreditAsIsPriceAdjustmentReview');
			}
		});
	}

	handleGoToStep(step, event) {
		event.preventDefault();
		browserHistory.push(step);
	}

	handleChangeAccountNumber(currentIndex, event) {
		const self = this;
		const accountNumber = event.target.value;
		const accountDetails = self.state.accountNumberDetails.find(itm => itm.ACCOUNTNUMBER === accountNumber);
		// make call to update sales price of this row
		const requestCreditDetails = self.state.requestCreditDetails;
		requestCreditDetails.responseObject.items[currentIndex].accountNumber = accountNumber;
		requestCreditDetails.responseObject.items[currentIndex].accountDescription = accountDetails ? accountDetails.ACCOUNTDESCRIPTION : '';
		requestCreditDetails.responseObject.items[currentIndex].accountNumberError = '';
		requestCreditDetails.responseObject.items[currentIndex].agreementNumber = '';
		requestCreditDetails.responseObject.items[currentIndex].agreementNumberError = '';
		requestCreditDetails.responseObject.items[currentIndex].shouldBePrice = '';
		requestCreditDetails.responseObject.items[currentIndex].shouldBePriceError = '';
		self.setState({
			requestCreditDetails,
			currentAccountNumber: accountNumber,
		}, () => {
			if (accountNumber) {
				const { accountNumberDetails } = self.state;
				const currentAccountDetails = accountNumberDetails.find(itm => itm.ACCOUNTNUMBER === accountNumber);
				if(currentAccountDetails && currentAccountDetails.agreementNumberList && currentAccountDetails.agreementNumberList.length === 0) {
					self.props.getPriceSources(accountNumber, false, selectedAccountsAllPriceSources => {
						const accountDetails = self.state.accountNumberDetails;
						accountDetails.forEach(itm => {
							if(itm.ACCOUNTNUMBER === self.state.currentAccountNumber) {
								itm.agreementNumberList = selectedAccountsAllPriceSources;
							}
						});
						self.setState({
							accountNumberDetails: accountDetails
						});
					});
				}
			}
		});
	}

	handleChangeSalesAgreementNumber(agreementNumberList, currentIndex, event) {
		const self = this;
		const agreementNumber = event.target.value;
		const agreementDetails = agreementNumberList.find(itm => itm.AGREEMENT_NUMBER.toString() === agreementNumber);
		// make call to update sales price of this row
		const requestCreditDetails = self.state.requestCreditDetails;
		requestCreditDetails.responseObject.items[currentIndex].agreementNumber = agreementNumber;
		requestCreditDetails.responseObject.items[currentIndex].agreementName = agreementDetails ? agreementDetails.AGREEMENT_NAME : '';
		requestCreditDetails.responseObject.items[currentIndex].agreementQuote = agreementDetails ? agreementDetails['Quote Type'] : '';
		requestCreditDetails.responseObject.items[currentIndex].agreementNumberError = '';
		let creditTypeAsIsSelected = requestCreditDetails.responseObject.creditType || self.state.creditType;
		self.setState({
			requestCreditDetails,
			currentIndex,
		}, () => {
			if(agreementNumber) {
				const orderDetails = self.state.requestCreditDetails.responseObject;
				const item = [orderDetails.items[self.state.currentIndex]];
				// If a ‘subbed for model’ is present, check price for the 'subbed for model' and the originalOrderDate.  If no price, show “no price found” message
				if (item[0].subbedModel) {
					self.makeSubbedModelPriceOrderCall(item, orderDetails.originalOrderDate);
				} else {
					// For the Should Be Price, call the price service with the original order date as the price date and the REBILL account & SA.
					self.props.makePriceOrderServiceCall(orderDetails, item, item[0].accountNumber, self.state.accountNumberDetails, orderDetails.originalOrderDate, false, creditTypeAsIsSelected, (response) => {
						const { requestCreditDetails, gotPricing, agreementQuote } = self.updateItemWithPricing(response.responseObject, item[0].item, orderDetails.originalOrderDate);
						// if we get prices then update state
						if (gotPricing) {
							delete requestCreditDetails.responseObject.items[self.state.currentIndex].subbedModelPrice;
							self.setState({
								requestCreditDetails
							});
						}
						// agreement type !== 'N'
						else if (agreementQuote !== 'N') {
							self.props.makePriceOrderServiceCall(orderDetails, item, item[0].accountNumber, self.state.accountNumberDetails, orderDetails.orderDate, false,creditTypeAsIsSelected,(response) => {
								const { requestCreditDetails, gotPricing } = self.updateItemWithPricing(response.responseObject, item[0].item, orderDetails.orderDate);
								if (gotPricing) {
									delete requestCreditDetails.responseObject.items[self.state.currentIndex].subbedModelPrice;
									self.setState({
										requestCreditDetails,
									});
								} else {
									self.setState({
										requestCreditDetails,
									});
								}
							});
						} else {
							self.setState({
								requestCreditDetails,
							});
						}
					});
				}
			}
		});
	}

	makeSubbedModelPriceOrderCall(item, orderDate) {
		const self = this;
		const orderDetails = self.state.requestCreditDetails.responseObject;
		// For the Should Be Price, call the price service with the original order date as the price date and the REBILL account & SA.
		const subbedItem = JSON.parse(JSON.stringify(item));
		subbedItem[0].item = subbedItem[0].subbedModel;
		self.props.makePriceOrderServiceCall(orderDetails, subbedItem, subbedItem[0].accountNumber, self.state.accountNumberDetails, orderDate, false,orderDetails.creditType, (response) => {
			const { requestCreditDetails } = self.updateItemWithPricing(response.responseObject, subbedItem[0].item, orderDate);
			requestCreditDetails.responseObject.items[self.state.currentIndex].subbedModelPrice = true;
			self.setState({
				requestCreditDetails,
			});
		});
	}

	updateItemWithPricing(pricingData, sku, orderDate) {
		const self = this;
		const { currentIndex } = self.state;
		let gotPricing = false;
		const requestCreditDetails = self.state.requestCreditDetails;
		let agreementQuote = '';
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			if(currentIndex === index) {
				let salesPriceData = pricingData ? _.find(pricingData, itm => {
					return itm.itemPrice.item === sku && item.returnQuantity.toString() === itm.itemPrice.qty.toString()
				}) : null;
				if (salesPriceData) {
					gotPricing = true;
					item.shouldBePrice = salesPriceData.itemPrice.salesPrice;
					item.originalShouldBePrice = salesPriceData.itemPrice.salesPrice;
					item.pricingDate =  self.props.pickTheDateFromString(item.pricingDate.split('T')[0])
					item.shouldBePriceError = "";
				} else {
					item.shouldBePrice = "";
					item.shouldBePriceError = "error";
					agreementQuote = item.agreementQuote;
				}
			}
		});
		return {
			requestCreditDetails,
			agreementQuote,
			gotPricing
		};
	}

	updateShouldBePrice(currentIndex, event) {
		const self = this;
		const requestCreditDetails = self.state.requestCreditDetails;
		requestCreditDetails.responseObject.items.forEach((item, index) => {
			if(currentIndex === index) {
				item.shouldBePrice = event.target.value.trim();
				item.shouldBePriceError = '';
			}
		});
		self.setState({
			requestCreditDetails,
		});
	}

	manipulateClipBoardOfShouldBePrice(index, event) {
		const clipboardData = event.clipboardData || window.clipboardData;
		let data = clipboardData.getData('Text').split('');
		let finalData = '';
		data.forEach(character => {
			if (!isNaN(character)) {
				finalData += character;
			}
		});
		if (window.clipboardData) {
			clipboardData.setData("Text", finalData);
		} else {
			clipboardData.setData('text/plain', finalData);
		}
		event.target.value = finalData;
		event.preventDefault();
		this.updateShouldBePrice(index, event);
	}

	render() {
		const self = this;

		const { creditType, accountNumberDetails } = self.state;
		const orderDetails = self.state.requestCreditDetails && self.state.requestCreditDetails.responseObject;
		let agreementNameDetailsFound = true;
		let isAllPricesAvailable = true;
		if (orderDetails && orderDetails.items && orderDetails.items.find(item => item.selected && !item.shouldBePrice)) {
			isAllPricesAvailable = false;
		}
        return (
			<div>
			{window.innerWidth > 600 && <div className="d-none d-sm-block">
		        <div className="push">
		        	<h1 className="pageTitle">Request Credit</h1>
		        </div>
		        <div className="push">
					{creditType === 'Price Adjustment - Credit/Rebill' && <p className="pad-b-1em">
						Please enter the "Should-Be Price" below to request a credit.
					</p>}
					{creditType === 'As-is Credit/Rebill' && (accountNumberDetails.length === 0 || !agreementNameDetailsFound) &&
						<p className="bold red">No valid AS-IS account is found.</p>
					}
					<p className="bold red"></p>
					<div className="captionAboveTable">
						<div className="columns">
							<div className="column column1">
								<b>CSO (Order number): {orderDetails && orderDetails.orderNumber}</b>
							</div>
							<div className="column column1">
								<b>Order Date: {orderDetails && orderDetails.originalOrderDate && this.props.formatDate(orderDetails.originalOrderDate, 'MM/DD/YY')}</b>
							</div>
							<div className="column column1">
								<b>P.O. # {orderDetails && orderDetails.poNumber}</b>
							</div>
						</div>
					</div>
					<table className="dataTable returnProductsOrderListTable">
						<thead>
							<tr>
								<th className="product">Product</th>
								<th className="description">Credit Quantity</th>
								<th className="invoiceNumber">Invoice #</th>
								<th className="text-center">Price<br/>(Each)</th>
								<th className="quantityOrdered">Account Number</th>
								<th className="quantityToReturn">Sales Agreement</th>
								<th>Should Be Price</th>
							</tr>
						</thead>
						<tbody>
							{orderDetails && orderDetails.items.map((item, index) => {
								if(!item.selected) return null;
								const accountNumberData = accountNumberDetails.find(itm => itm.ACCOUNTNUMBER === item.accountNumber);
								const agreementNumberList = accountNumberData ? accountNumberData.agreementNumberList : [];
								if (agreementNumberList.length === 0) {
									agreementNameDetailsFound = false;
								}
								return <tr key={index}>
									<td className="product">
										{item.item}
										{item.subbedModel && <div>
											<strong>Subbed for model:</strong> {item.subbedModel}
										</div>}
									</td>
									<td className="description">{item.returnQuantity}</td>
									<td className="invoiceNumber">{item.invoiceNumber}</td>
									<td className="text-right">{self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</td>
									<td className="quantityToReturn">
										<select disabled={item.subbedModel} onChange={this.handleChangeAccountNumber.bind(this, index)} className={item.accountNumberError + ' accountNumber'} value={item.accountNumber} id={"accountNumber"+index} name="accountNumber" style={{ width: '100%' }}>
											<option value="" key={0}>-- Select --</option>
											{accountNumberDetails.map((acct, index) => {
												return <option value={acct.ACCOUNTNUMBER} key={(index + 1)}>{`${acct.ACCOUNTNUMBER} ${acct.ACCOUNTDESCRIPTION}`}</option>
											})}
										</select>
									</td>
									<td className="quantityToReturn">
										<select onChange={this.handleChangeSalesAgreementNumber.bind(this, agreementNumberList, index)} className={item.agreementNumberError + ' agreementNumber'} value={item.agreementNumber} id={"agreementNumber"+index} name="agreementNumber" style={{ width: '100%' }}>
											<option value="" key={0}>-- Select --</option>
											{agreementNumberList.map((item, index) => {
												return <option value={item.AGREEMENT_NUMBER.toString()} key={(index + 1)}>{item.DISPLAY_AGREEMENT_NAME}</option>
											})}
										</select>
									</td>
									<td className={`ws-nowrap text-right ${item.shouldBePriceError}`}>
										{item.subbedModel
											?(item.shouldBePrice
												? self.props.formatMoney(item.shouldBePrice, 0, ".", ",", false, "$")
												: <span className="red">No price found</span>
											)
											:<div>
												
												{(creditType === 'As-is Credit/Rebill'
													? item.shouldBePrice && self.props.formatMoney(item.shouldBePrice, 0, ".", ",", false, "$")
													: <div>$ <input onPaste={this.manipulateClipBoardOfShouldBePrice.bind(this, index)} onChange={this.updateShouldBePrice.bind(this, index)} onKeyPress={this.props.acceptNumbersAndDotOnly} type="text" name="shouldBePrice" disabled={!item.shouldBePrice} value={item.shouldBePrice} style={{width: 60, display: 'inline-block'}} /></div>
												)}
												{!item.shouldBePrice && <div className="red">No price found</div>}
												</div>
										}

									</td>
								</tr>
							})}
						</tbody>
					</table>
					<div className="columns">
						<div className="column">
							<input onClick={(e) => this.handleGoToStep('/requestcredit', e)} type="button" defaultValue="Cancel" className="blueButton" />
						</div>
						{isAllPricesAvailable && <div className="column textRight">
							<input type="submit" onClick={this.handleContinue.bind(this)} value="Continue" />
						</div>}
					</div>
					<p>
						<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep2', e)} className="bold">Return to previous screen</a>
					</p>
				</div>
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
			</div>
			}
			{/*Mobile view*/}

			<div className="d-block d-sm-none container">
			
				<div className="push">
		        	<h1 className="pageTitle">Request Credit</h1>
		        </div>

				<div>
					{creditType === 'Price Adjustment - Credit/Rebill' && <p className="pad-b-1em">
						Please enter the "Should-Be Price" below to request a credit.
					</p>}
					{creditType === 'As-is Credit/Rebill' && (accountNumberDetails.length === 0 || !agreementNameDetailsFound) &&
						<p className="bold red">No valid AS-IS account is found.</p>
					}
					<p className="bold red"></p>
				</div>

				<div className='container headerColor captionContainer'>
						<div className='row'>
							<div className='col-5 d-flex align-items-center'>
								<div>CSO (Order number): {orderDetails && orderDetails.orderNumber}</div>
								<div className="vr vrLinePosition vrLineWidth"></div>
							</div>
							<div className='col-4 d-flex align-items-center'>
								<div>
								Order Date: {orderDetails && orderDetails.originalOrderDate && this.props.formatDate(orderDetails.originalOrderDate, 'MM/DD/YY')}
								</div>
								<div className="vr vrLineWidth"></div>
							</div>
							<div className='col-3 d-flex align-items-center'>
								<div>
								P.O. # {orderDetails && orderDetails.poNumber}
								</div>
							</div>
						</div>
					</div>
					{orderDetails && orderDetails.items.map((item, index) => {
								if(!item.selected) return null;
								const accountNumberData = accountNumberDetails.find(itm => itm.ACCOUNTNUMBER === item.accountNumber);
								const agreementNumberList = accountNumberData ? accountNumberData.agreementNumberList : [];
								if (agreementNumberList.length === 0) {
									agreementNameDetailsFound = false;
								}
					return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCreditPriceAdj${index}`}  key={index}>
									<div className="accordion-item">

										<h2 className="accordion-header" id={`headingReturnCreditPriceAdj${index}`}>
											<button className="accBtn accordion-button font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapseReturnCreditPriceAdj${index}`} aria-expanded="true" aria-controls={`collapseReturnCreditPriceAdj${index}`}>
												<span className='spaceBetweenText'>PRODUCT</span>  {item.item}
											</button>
										</h2>	

										<div id={`collapseReturnCreditPriceAdj${index}`}
															className='accordion-collapse collapse accBody show' 
															aria-labelledby={`headingReturnStep1${index}`}
															show>

											<div className="">
												
											<div className="row ">
													<div className="col-8 fw-bold pt-3">Credit Quantity</div>
													<div className="col-4 text-end pt-3">
														{item.returnQuantity}
													</div>
													<hr className="hr hrSpec" />
											</div>
											
												<div className="row ">
													<div className="col-8 fw-bold">Invoice #</div>
													<div className="col-4 text-end">{item.invoiceNumber}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-8 fw-bold">Price (Each)</div>
													<div className="col-4 text-end">{self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</div>
													<hr className="hr hrSpec" />
												</div>

												

												<div className="row ">
													<div className="col-6 fw-bold">Account Number</div>
													<div className="col-6 text-end">
														<select disabled={item.subbedModel} onChange={this.handleChangeAccountNumber.bind(this, index)} className="form-select float-end w-100" value={item.accountNumber} id={"accountNumber"+index} name="accountNumber" style={{ width: '100%' }}>
															<option value="" key={0}>-- Select --</option>
															{accountNumberDetails.map((acct, index) => {
																return <option value={acct.ACCOUNTNUMBER} key={(index + 1)}>{`${acct.ACCOUNTNUMBER} ${acct.ACCOUNTDESCRIPTION}`}</option>
															})}
														</select>

													</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-6 fw-bold">Sales Agreement</div>
													<div className="col-6 text-end">
													<select onChange={this.handleChangeSalesAgreementNumber.bind(this, agreementNumberList, index)} className="form-select float-end w-100" value={item.agreementNumber} id={"agreementNumber"+index} name="agreementNumber" style={{ width: '100%' }}>
														<option value="" key={0}>-- Select --</option>
														{agreementNumberList.map((item, index) => {
															return <option value={item.AGREEMENT_NUMBER.toString()} key={(index + 1)}>{item.DISPLAY_AGREEMENT_NAME}</option>
														})}
													</select>

													</div>
													<hr className="hr hrSpec" />
												</div>

												<div className={item.subbedModel ? "row" : "row mb-3"}>
													<div className="col-6 fw-bold">Should Be Price</div>
													<div className="col-6 text-end">
														{item.subbedModel
																	?(item.shouldBePrice
																		? self.props.formatMoney(item.shouldBePrice, 0, ".", ",", false, "$")
																		: <div className="red">No price found</div>
																	)
																	:

																	<div>
																		{(creditType === 'As-is Credit/Rebill'
																			? item.shouldBePrice && self.props.formatMoney(item.shouldBePrice, 0, ".", ",", false, "$")
																			: <div>$ <input onPaste={this.manipulateClipBoardOfShouldBePrice.bind(this, index)} onChange={this.updateShouldBePrice.bind(this, index)} onKeyPress={this.props.acceptNumbersAndDotOnly} type="text" name="shouldBePrice" value={item.shouldBePrice} style={{width: 60, display: 'inline-block'}} /></div>
																		)}
																		{!item.shouldBePrice && <div className="red mt-2">No price found</div>}
																	</div>
															}
													</div>
													{item.subbedModel && <hr className="hr hrSpec" /> }
												</div>

												{item.subbedModel && <div className="row mb-3">
													<div className="col-6 fw-bold">Subbed for model</div>
													<div className="col-6 text-end overFlowWrap">
														{item.subbedModel}
													</div>
												</div>}
												
											</div>
										</div>
									</div>
								</div>
							})}



				<div className="d-flex justify-content-between mt-3 ps-1 pe-1">
							<span>
								<button id="cancelButton" className='btnSize cancelButtonSpec' onClick={(e) => this.handleGoToStep('/requestcredit', e)}>Cancel</button>
							</span>
							
							{isAllPricesAvailable &&<span>
								<button id="continueButton" className='btnSize' onClick={this.handleContinue.bind(this)}>Continue</button>
							</span>}
						</div>
					

					<div className="container mt-4 backLink ">
					<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep2', e)} className="bold">Return to previous screen</a>
					</div> 

					<div style={{height:"200px"}}></div>

			</div>

			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setRequestCreditDetails: (data) => dispatch(setRequestCreditDetails(data)),
});

RequestCreditAsIsPriceAdjustment = connect(mapStateToProps, mapDispatchToProps)(RequestCreditAsIsPriceAdjustment);
export default RequestCreditAsIsPriceAdjustment;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCreditAsIsPriceAdjustment.js